// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b9097219","186":"46084c08","215":"99d1c6fb","372":"a58bc666","377":"a5394c10","738":"75df13be","841":"bdd4185c","851":"c3974b73","856":"def06885"}[chunkId] + ".chunk.js";
};